import FixedNavBar from "@/components/fixedNavBar";
import useCustomTranslation from "@/hooks/useTranslation";
import { Swiper, SwiperRef, Tabs, Image, SafeArea } from "antd-mobile";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { createUseStyles } from "react-jss";
import DepositModule from "./comp/Deposit";
import WithdrawalModule from "./comp/Withdrawal";
import RecordModule from "./comp/Record";
import { pxToRem } from "@/util/common";
import useRouter from "@/hooks/useRouter";
import { getApiAppConfig } from "@/redux/reducers/config";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@/redux/store";

export enum WalletTabKeys {
	FRUITS = "fruits",
	VEGETABLES = "vegetables",
	ANIMALS = "animals",
}
export type TabType = "DepositRecords" | "AccessRecords";
export type ModuleProps = {
	onChange: (newValue: string, active?: TabType) => void;
};

export type CoinGamingData = {
	currency: string | null;
	feeRate: number | undefined;
	address: string | null;
	orderId: string;
	time: string;
	type: string;
	logo: string;
	network: string;
	status?: number;
	reason?: string;
	uri?: string;
} | null;

const RecordModuleChildComponent = forwardRef(RecordModule);
const tabItems: {
	key: string;
	icon: string;
	title: string;
}[] = [
	{
		key: "fruits",
		icon: "arrow-circle-broken-down",
		title: "btnDepositMoney",
	},
	{
		key: "vegetables",
		icon: "arrow-circle-broken-up",
		title: "btnWithdrawal",
	},
	{
		key: "animals",
		icon: "record",
		title: "btnDepositWithdrawRecords",
	},
];

const WalletPage: React.FC = () => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { t } = useCustomTranslation();
	const { params: routerParams } = useRouter();
	const childRef = useRef<any>(null);
	const swiperRef = useRef<SwiperRef>(null);
	const [activeIndex, setActiveIndex] = useState(
		routerParams.state ? +routerParams.state : 0
	);

	const handleTabChange = (key: string, active?: TabType) => {
		const index = tabItems.findIndex((item) => item.key === key);
		setActiveIndex(index);
		swiperRef.current?.swipeTo(index);
		if (active && childRef.current) {
			childRef.current.tabChange(active);
		}
	};

	useEffect(() => {
		dispatch(getApiAppConfig({}));
	}, [dispatch]);

	return (
		<div className="router-main">
			<FixedNavBar title={`${t("Wallet")}`} />
			<Tabs
				className={classes.tabsWrap}
				activeKey={tabItems[activeIndex].key}
				onChange={handleTabChange}
				activeLineMode="fixed"
				style={{
					color: "#FFFFFF",
					"--active-title-color": "#FFFFFF",
					"--active-line-height": "0",
					"--title-font-size": pxToRem(14),
				}}
			>
				{tabItems.map((item) => (
					<Tabs.Tab
						title={
							<div className="customTitle">
								<Image
									src={require("@/assets/images/icons/" +
										item.icon +
										".png")}
									className="icon"
								/>
								<span>{t("" + item.title)}</span>
							</div>
						}
						key={item.key}
					/>
				))}
			</Tabs>
			<Swiper
				direction="horizontal"
				loop
				indicator={() => null}
				ref={swiperRef}
				defaultIndex={activeIndex}
				onIndexChange={(index) => {
					setActiveIndex(index);
				}}
			>
				{tabItems.map((item) => (
					<Swiper.Item key={item.key}>
						{item.key === "animals" ? (
							<RecordModuleChildComponent
								ref={childRef}
								key={item.key}
							/>
						) : item.key === "fruits" ? (
							<DepositModule
								key={item.key}
								onChange={handleTabChange}
							/>
						) : (
							<WithdrawalModule
								key={item.key}
								onChange={handleTabChange}
							/>
						)}
					</Swiper.Item>
				))}
			</Swiper>
			<SafeArea position="bottom" />
		</div>
	);
};

export default WalletPage;

const useStyles = createUseStyles({
	tabsWrap: {
		height: pxToRem(40),
		color: "#FFFFFF",
		borderRadius: pxToRem(40),
		margin: {
			left: pxToRem(20),
			right: pxToRem(20),
		},
		backgroundColor: "#191B23",
		"& .adm-tabs-tab-list": {
			overflowX: "inherit",
		},
		"& .adm-tabs-tab-wrapper, & .adm-tabs-tab": {
			flex: 1,
			padding: {
				top: 0,
				bottom: 0,
			},
		},
		"& .adm-tabs-header": {
			borderBottom: 0,
		},
		"& .adm-tabs-tab": {
			height: pxToRem(40),
			lineHeight: pxToRem(40),
		},
		"& .adm-tabs-tab-active": {
			position: "relative",
			width: "100%",
			textAlign: "center",
			borderRadius: pxToRem(40),
			background: "linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
			boxShadow:
				"0px 2px 4px 0px #00C2FF40 inset, 0px 10px 10px 1px #184DED4D",
		},

		"& .customTitle": {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			"& .icon": {
				width: pxToRem(20),
				height: pxToRem(20),
				marginRight: pxToRem(5),
			},
			"& span": {
				fontFamily: "Noto Sans SC",
				fontSize: pxToRem(14),
				fontWeight: 500,
				color: "#FFFFFF",
			},
		},
	},
});
